import React, { useEffect, useState } from "react";
import { Container, Table, Form, Pagination, Offcanvas, } from "react-bootstrap";
import {
  FiTrash2, FiFile, FiFilter, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { getNote, deleteNote } from "../../store/slices/notes";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getClassSubject } from "../../store/slices/subject";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function AdminNotes() {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    standardId: "",
    sectionId: "",
    subjectId: "",
  });
  const itemsPerPage = 25;
  const [totalData, setTotalData] = useState(0);

  const [standardList, setStandardList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);

  const [standardId, setStandardId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [subjectId, setSubjectId] = useState("");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false);

  // get std and sec <-------------- 
  useEffect(() => {
    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {
        const normalized = (res?.data || []).map((item) => ({
          _id: item.standardId?._id,
          name: item.standardId?.name,
          sections: item.sectionId || [],
        }));
        setStandardList(normalized);
      })
      .catch(() => toast.error("Failed to fetch standard & section"));
  }, []);

  // ------------- > get subject
  useEffect(() => {
    if (!standardId || !sectionId) return;

    dispatch(getClassSubject({ standardId, sectionId }))
      .unwrap()
      .then((res) => {
        const subjects =
          res?.data?.[0]?.subjectId?.filter((s) => s.status === 1) || [];
        setSubjectList(subjects);
      })
      .catch(() => toast.error("Failed to fetch subject"));
  }, [standardId, sectionId]);

  // getNotes <-------------------
  const fetchNotes = (filterData = {}) => {
    setIsLoading(true);

    dispatch(getNote(filterData))
      .unwrap()
      .then((res) => {
        setData(res?.data || []);
        setTotalData(res?.totalDataCount || 0);
        setCurrentPage(1);
      })
      .catch(() => {
        toast.error("Failed to fetch notes");
        setData([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const handleFilter = () => {
    const filterData = {
      standardId,
      sectionId,
      subjectId,
    };

    setFilters(filterData);
    setCurrentPage(1);
    fetchNotes(filterData, 1);
    setShowFilterDrawer(false);
  };


  const handleClear = () => {
    setStandardId("");
    setSectionId("");
    setSubjectId("");
    setSubjectList([]);
    fetchNotes();
  };

  // delete row
  const handleDeleteRow = (id) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;

    dispatch(deleteNote(id))
      .unwrap()
      .then(() => {
        toast.success("Note deleted successfully");
        fetchNotes();
      })
      .catch(() => {
        toast.error("Failed to delete note");
      });
  };



  // Pagination
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Container fluid>
      {/* Header */}
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <FiHome />
            </div>

            <FiChevronRight className="separator" />

            <Link to="/teacher/home">Home</Link>

            <FiChevronRight className="separator" />

            <span className="active">Notes</span>
          </div>


          <div className="d-flex gap-2">
            <button
              className="btn-cancel d-flex align-items-center gap-2"
              onClick={() => setShowFilterDrawer(true)}
            >
              <FiFilter />
              Filter
            </button>


          </div>
        </div>
      </div>


      <div className="staff-card">

        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Standard</th>
                <th className="text-center">Subject</th>
                <th className="text-center">Chapter</th>
                <th className="text-center">Notes</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <Skeleton width={20} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={90} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={120} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={170} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={90} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={90} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={60} />
                    </td>

                    <td className="text-center">
                      <div className="d-flex justify-content-center">
                        <Skeleton
                          width={36}
                          height={36}
                          borderRadius={10}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : paginatedData.length ? (
                paginatedData.map((item, i) => (
                  <tr key={item._id}>

                    <td className="text-center">{startIndex + i + 1}</td>
                    <td className="text-center">{item.standardId?.name}</td>
                    <td className="text-center">
                      {item.subjectId?.name}
                    </td>
                    <td className="text-center">
                      {item.chapter}
                    </td>
                    <td className="text-center">
                      {item.file ? (
                        <a href={item.file} target="_blank" rel="noreferrer">
                          <FiFile />
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      <button
                        className="edit-btn"
                        onClick={() => handleDeleteRow(item._id)}
                      >  <FiTrash2 size={15} /></button>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    No notes found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div>

      {/* ----------- > right side drawer */}
      <Offcanvas
        show={showFilterDrawer}
        onHide={() => setShowFilterDrawer(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filter Notes</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Form.Select
            className="mb-3"
            value={standardId}
            onChange={(e) => {
              setStandardId(e.target.value);
              setSectionId("");
              setSubjectId("");
              setSubjectList([]);
            }}
          >
            <option value="">Select Standard</option>
            {standardList.map((std) => (
              <option key={std._id} value={std._id}>
                {std.name}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            className="mb-3"
            value={sectionId}
            disabled={!standardId}
            onChange={(e) => {
              setSectionId(e.target.value);
              setSubjectId("");
            }}
          >
            <option value="">Select Section</option>
            {standardList
              .find((s) => s._id === standardId)
              ?.sections?.map((sec) => (
                <option key={sec._id} value={sec._id}>
                  {sec.name}
                </option>
              ))}
          </Form.Select>

          <Form.Select
            className="mb-3"
            value={subjectId}
            disabled={!sectionId}
            onChange={(e) => setSubjectId(e.target.value)}
          >
            <option value="">Select Subject</option>
            {subjectList.map((sub) => (
              <option key={sub._id} value={sub._id}>
                {sub.name}
              </option>
            ))}
          </Form.Select>

          <div className="d-flex gap-2">

            <button className="btn-cancel w-100" onClick={handleClear}>
              Clear
            </button>
            <button className="btn-submit w-100" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}
